/**
 * Project panel
 * NumberField.js
 * Created by stefensuhat on 2019-03-29 19:45
 */

import { InputAdornment, TextField as TF } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

const propTypes = { inputProps: PropTypes.object };
const defaultProps = { inputProps: {} };

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator
        />
    );
}

function NumberField({
    onChange, value, prefix, suffix, form, field, helperText, ...props
}) {
    return (
        <TF
            {...props}
            error={!!form.errors[field.name]}
            value={form.values[field.name]}
            onChange={(e) => form.setFieldValue(field.name, e.target.value)}
            InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: <InputAdornment disableTypography position="start">{prefix}</InputAdornment>,
                endAdornment: <InputAdornment disableTypography position="end">{suffix}</InputAdornment>,
            }}
            helperText={form.errors[field.name] || helperText}
        />

    );
}

NumberField.propTypes = propTypes;
NumberField.defaultProps = defaultProps;

export default NumberField;
